(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["Lodash"], factory);
	else if(typeof exports === 'object')
		exports["getRemote"] = factory(require("lodash"));
	else
		root["getRemote"] = factory(root["Lodash"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__783__) => {
return 